import { render, staticRenderFns } from "./questionManageBar.vue?vue&type=template&id=3bb9754a&scoped=true&"
import script from "./questionManageBar.vue?vue&type=script&lang=js&"
export * from "./questionManageBar.vue?vue&type=script&lang=js&"
import style0 from "./questionManageBar.vue?vue&type=style&index=0&id=3bb9754a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb9754a",
  null
  
)

export default component.exports